import { defineCustomElement } from '@tyler-components-web/core';
import { InlineMessageComponent } from './inline-message';
export * from './inline-message-constants';
export * from './inline-message';
export function defineInlineMessageComponent() {
    defineCustomElement(InlineMessageComponent);
}
